import 'moment/locale/fr';
import { APIcaller } from './APIcaller';
import moment from 'moment';

moment.locale('fr');

function patchEvent(id, storeId, eventSubCategoryId, startDate, endDate, name) {
  const payload = {
    eventSubCategoryId,
    startDate,
    endDate,
    name,
  };

  if (id) {
    // Update existing event
    return APIcaller.apiPatch(`/admin/events/store/${storeId}/custom/${id}`, payload);
  } else {
    // Create new event
    return APIcaller.apiPost(`/admin/events/store/${storeId}/custom`, payload);
  }
}

function deleteEventById(eventId, storeId) {
  return APIcaller.apiDelete(`/admin/events/store/${storeId}/custom/${eventId}`);
}

export const event = {
  patchEvent,
  deleteEventById,
};
